var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.674,
    height: 39.99,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.705 5.67 3.757 3.11 3.756-3.11-3.756-3.11Zm3.757 5.66L5.624 5.67 12.462 0 19.3 5.67ZM52.873 39.99a5.439 5.439 0 0 1-5.431-5.43h1.966a3.466 3.466 0 0 0 3.466 3.46 3.466 3.466 0 0 0 3.466-3.46h1.966a5.439 5.439 0 0 1-5.431 5.43M41.171 39.99a5.439 5.439 0 0 1-5.431-5.43h1.966a3.466 3.466 0 0 0 3.466 3.46 3.466 3.466 0 0 0 3.466-3.46h1.966a5.439 5.439 0 0 1-5.431 5.43M22.401 39.99a5.439 5.439 0 0 1-5.431-5.43h1.966a3.466 3.466 0 0 0 3.466 3.46 3.466 3.466 0 0 0 3.466-3.46h1.966a5.44 5.44 0 0 1-5.432 5.43M10.701 39.99a5.44 5.44 0 0 1-5.432-5.43h1.966a3.466 3.466 0 0 0 3.466 3.46 3.466 3.466 0 0 0 3.466-3.46h1.966a5.439 5.439 0 0 1-5.431 5.43",
    fill: "#3cb36f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.673 34.69H0V14.58a3.949 3.949 0 0 1 3.947-3.94h54.78a3.949 3.949 0 0 1 3.947 3.94Z",
    fill: "#3cb36f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.816 23.89h4.085v-6.485H1.816ZM56.998 23.89h3.829v-6.485h-3.829ZM14.016 23.89h7.464v-6.485h-7.464ZM22.85 23.89h7.466v-6.485H22.85ZM32.19 23.89h7.464v-6.485H32.19ZM41.024 23.89h7.464v-6.485h-7.464Z",
    fill: "#ebf5eb",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.116 8.1a.871.871 0 0 0-.869.87v.84a.871.871 0 0 0 .869.87h7.6a.871.871 0 0 0 .87-.87v-.84a.871.871 0 0 0-.87-.87Zm7.6 4.54h-7.6a2.836 2.836 0 0 1-2.835-2.83v-.84a2.838 2.838 0 0 1 2.835-2.84h7.6a2.838 2.838 0 0 1 2.835 2.84v.84a2.836 2.836 0 0 1-2.835 2.83M44.359 8.1a.871.871 0 0 0-.869.87v.84a.871.871 0 0 0 .869.87h7.6a.871.871 0 0 0 .87-.87v-.84a.871.871 0 0 0-.87-.87Zm7.6 4.54h-7.6a2.836 2.836 0 0 1-2.835-2.83v-.84a2.838 2.838 0 0 1 2.835-2.84h7.6a2.838 2.838 0 0 1 2.835 2.84v.84a2.836 2.836 0 0 1-2.835 2.83",
    fill: "#3cb36f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.806 28.86h59.282v-2.271H1.806Z",
    fill: "#ebf5eb",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.7d8d24ef4e42dc30f8adc4a18e562ccd.svg";
export { ForwardRef as ReactComponent };